module.exports = __webpack_public_path__ + "static/img/a_42_m.c27769a1.png";